{
  "MaxfilterlistlimitLabel": "Limite massimo dell'elenco dei filtri:",
  "MaxreportrowdisplimitLabel": "Limite massimo di visualizzazione delle righe del report:",
  "MaxfilterlistlimitPlaceholder": "150",
  "MaxreportrowdisplimitPlaceholder": "150",
  "ContentRestriction_SectionHeader": "Limitazione dei contenuti",
  "ContentRestriction_SectionPara": "Per gli ambienti con un numero elevato di dispositivi e\/o agenti ACD, è possibile aumentare il numero massimo di ",
  "NAME": "ContentRestriction"
}